define('collections/Podio.Collections.Subscriptions',['require','underscore','lib/backbone/Backbone.PodioCollection','lib/Podio.Routes'],function(require) {

  var _ = require('underscore');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var routes = require('lib/Podio.Routes');

  return PodioCollection.extend({

    getByReference: function(refType, refId) {

      var req = this.request('get', routes.subscriptions_path(refType, refId), {});

      req.done(_.bind(function(responseData) {
        this.reset(responseData.data.subscriptions);
      }, this));

      return req;

    }

  });

});

